import type { SVGProps } from "react";

const ComapaniesIcon = ({
  width = 30,
  height = 30,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 30 30"
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M26.141 7.361c.422.63.422 1.509.422 3.264v15.938h.625a.938.938 0 0 1 0 1.875h-25a.937.937 0 1 1 0-1.875h.624V10.625c0-1.755 0-2.633.422-3.264a2.5 2.5 0 0 1 .69-.69c.551-.368 3.17-.414 4.522-.42-.005.364-.005.745-.005 1.137v1.675H5.312a.938.938 0 0 0 0 1.875h3.13v1.875h-3.13a.937.937 0 1 0 0 1.875h3.13v1.875h-3.13a.937.937 0 1 0 0 1.875h3.13v8.125h12.5v-8.125h3.12a.937.937 0 1 0 0-1.875h-3.12v-1.875h3.12a.937.937 0 1 0 0-1.875h-3.12v-1.875h3.12a.938.938 0 0 0 0-1.875h-3.12V7.388c0-.392 0-.773-.006-1.137 1.352.006 3.964.052 4.515.42.273.183.508.417.69.69Z"
      opacity={0.5}
    />
    <path
      fill="#000"
      fillRule="evenodd"
      d="M13.438 2.5h2.5c2.356 0 3.535 0 4.267.732.733.732.733 1.911.733 4.268v19.063h6.25a.938.938 0 0 1 0 1.875h-25a.938.938 0 0 1 0-1.875h6.249V7.5c0-2.357 0-3.536.733-4.268.732-.732 1.91-.732 4.268-.732Zm1.25 20.313c.517 0 .937.42.937.937v2.813H13.75V23.75c0-.518.42-.938.938-.938Zm-2.5-5.313a.938.938 0 0 0 0 1.875h5a.938.938 0 0 0 0-1.875h-5Zm-.938-2.813c0-.517.42-.937.938-.937h5a.938.938 0 0 1 0 1.875h-5a.938.938 0 0 1-.938-.938Zm.938-4.062a.937.937 0 1 0 0 1.875h5a.938.938 0 0 0 0-1.875h-5Zm-.938-2.813c0-.517.42-.937.938-.937h5a.938.938 0 0 1 0 1.875h-5a.937.937 0 0 1-.938-.938Z"
      clipRule="evenodd"
    />
  </svg>
);
export default ComapaniesIcon;
